import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { RequestsList } from "entities/requests";

export const RequestsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Title level={1}>{t("requests.title")}</Typography.Title>
      <RequestsList />
    </>
  );
};
